const t = {
  "cdr-switch": "cdr-switch_15-6-1-beta-4",
  "cdr-switch__button": "cdr-switch__button_15-6-1-beta-4",
  "cdr-switch__button-icon": "cdr-switch__button-icon_15-6-1-beta-4",
  "cdr-switch__handle": "cdr-switch__handle_15-6-1-beta-4",
  "cdr-switch__label": "cdr-switch__label_15-6-1-beta-4",
  "cdr-switch--full-width": "cdr-switch--full-width_15-6-1-beta-4",
  "cdr-switch--large": "cdr-switch--large_15-6-1-beta-4",
  "cdr-switch--medium": "cdr-switch--medium_15-6-1-beta-4"
};
export {
  t as default
};
